"use client";

import { useRouter } from "next/navigation";
import { signIn } from "next-auth/react";
import { Controller, useForm } from "react-hook-form";
import { Button, Divider, Input } from "antd";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { useState } from "react";

export const LoginForm = ({ searchParams }) => {
    const router = useRouter();
    const {
        register,
        handleSubmit,
        control,
        formState: { errors },
    } = useForm();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    const onLogin = async (data) => {
        setError(false);
        setLoading(true);
        const { username, password } = data;
        const result = await signIn("credentials", {
            redirect: false,
            username: username,
            password: password,
        });
        if (result?.ok) {
            // if (searchParams?.redirect) {
            //     router.push(searchParams.redirect);
            // } else {
            //     router.push(`/`);
            // }
            router.push(`/settings`);
        } else {
            setError(true);
            setLoading(false);
        }
    };

    // Надо изучть https://react-hook-form.com/get-started#IntegratingwithUIlibraries
    return (
        <form onSubmit={handleSubmit(onLogin)}>
            <div className="flex flex-col space-y-6">
                {/* <Button
                    loading={loading}
                    disabled={loading}
                    type="primary"
                    onClick={() => {
                        onLogin({ username: "ad", password: "ad" });
                    }}
                    className="bg-button"
                >
                    Войти как корпоративный пользователь
                </Button>
                <Divider>или</Divider> */}
                <div className="flex flex-col">
                    {/* <label>Username</label> */}
                    <Controller
                        name="username"
                        control={control}
                        render={({ field }) => (
                            <Input
                                prefix={<UserOutlined />}
                                {...field}
                                type="text"
                                autoFocus
                                autoComplete="username"
                                required
                                placeholder="Доменная учетная запись"
                            />
                        )}
                    />
                </div>
                <div className="flex flex-col">
                    {/* <label>Password</label> */}
                    <Controller
                        name="password"
                        control={control}
                        render={({ field }) => (
                            <Input.Password
                                prefix={<LockOutlined />}
                                {...field}
                                autoComplete="password"
                                required
                                placeholder="Пароль"
                                // visibilityToggle={false}
                            />
                        )}
                    />
                </div>
                <Button loading={loading} disabled={loading} type="primary" htmlType="submit" className="bg-button">
                    Войти по учетным данным
                </Button>
                {error && (
                    <div className="flex justify-center text-sm">
                        <div>Не удалось войти</div>
                    </div>
                )}
            </div>
        </form>
    );
};
